export const ExperienceItems = [
  {
    type: "work", // either school or work
    orientation: "right", // refers to which side text is on
    imageLink: "/images/experience/squarepoint.jpeg",
    roleTitle: "experience:experience8.title",
    roleLocation: "experience:experience8.location",
    roleDate: "experience:experience8.date",
    tags: [
      {
        name: "Python",
        level: 3,
      },
      {
        name: "React",
        level: 3,
      },
    ],
    points: [
      {
        text: "experience:experience8.points.point1",
      },
      {
        text: "experience:experience8.points.point2",
      },
      {
        text: "experience:experience8.points.point3",
      },
    ],
  },
  {
    type: "work", // either school or work
    orientation: "left", // refers to which side text is on
    imageLink: "/images/experience/drw.jpg",
    roleTitle: "experience:experience7.title",
    roleLocation: "experience:experience7.location",
    roleDate: "experience:experience7.date",
    tags: [
      {
        name: "Go",
        level: 3,
      },
      {
        name: "Amazon SQS",
        level: 2,
      },
      {
        name: "Faktory",
        level: 2,
      },
    ],
    points: [
      {
        text: "experience:experience7.points.point1",
      },
      {
        text: "experience:experience7.points.point2",
      },
      {
        text: "experience:experience7.points.point3",
      },
    ],
  },
  {
    type: "school", // either school or work
    orientation: "right", // refers to which side text is on
    imageLink: "/images/experience/h4i.jpg",
    roleTitle: "experience:experience6.title",
    roleLocation: "experience:experience6.location",
    roleDate: "experience:experience6.date",
    tags: [
      {
        name: "React.js",
        level: 3,
      },
      {
        name: "Flask",
        level: 3,
      },
      {
        name: "Postgres",
        level: 3,
      },
    ],
    points: [
      {
        text: "experience:experience6.points.point1",
      },
      {
        text: "experience:experience6.points.point2",
      },
      {
        text: "experience:experience6.points.point3",
      },
    ],
  },
  {
    type: "work", // either school or work
    orientation: "left", // refers to which side text is on
    imageLink: "/images/experience/cloudops.jpg",
    roleTitle: "experience:experience5.title",
    roleLocation: "experience:experience5.location",
    roleDate: "experience:experience5.date",
    tags: [
      {
        name: "Java Springboot",
        level: 3,
      },
      {
        name: "Vue.js",
        level: 3,
      },
      {
        name: "Groovy/Jest",
        level: 2,
      },
      {
        name: "Jira/Jenkins",
        level: 2,
      },
    ],
    points: [
      {
        text: "experience:experience5.points.point1",
      },
      {
        text: "experience:experience5.points.point2",
      },
      {
        text: "experience:experience5.points.point3",
      },
      {
        text: "experience:experience5.points.point4",
      },
      {
        text: "experience:experience5.points.point5",
      },
    ],
  },
  {
    type: "school", // either school or work
    orientation: "right", // refers to which side text is on
    imageLink: "/images/experience/enactus.jpg",
    roleTitle: "experience:experience4.title",
    roleLocation: "experience:experience4.location",
    roleDate: "experience:experience4.date",
    tags: [
      {
        name: "MERN",
        level: 3,
      },
      {
        name: "Git",
        level: 3,
      },
      {
        name: "Material UI",
        level: 2,
      },
      {
        name: "Redux",
        level: 2,
      },
    ],
    points: [
      {
        text: "experience:experience4.points.point1",
      },
      {
        text: "experience:experience4.points.point2",
      },
      {
        text: "experience:experience4.points.point3",
      },
    ],
  },
  {
    type: "work", // either school or work
    orientation: "left", // refers to which side text is on
    imageLink: "/images/experience/mcgill.jpg",
    roleTitle: "experience:experience3.title",
    roleLocation: "experience:experience3.location",
    roleDate: "experience:experience3.date",
    tags: [
      {
        name: "Git",
        level: 3,
      },
      {
        name: "Python",
        level: 3,
      },
      {
        name: "RocksDB",
        level: 2,
      },
      {
        name: "Unix/Linux",
        level: 2,
      },
      {
        name: "C",
        level: 2,
      },
      {
        name: "C++",
        level: 2,
      },
    ],
    points: [
      {
        text: "experience:experience3.points.point1",
      },
      {
        text: "experience:experience3.points.point2",
      },
      {
        text: "experience:experience3.points.point3",
      },
      {
        text: "experience:experience3.points.point4",
      },
    ],
  },
  {
    type: "school", // either school or work
    orientation: "right", // refers to which side image is on
    imageLink: "/images/experience/discord.png",
    roleTitle: "experience:experience2.title",
    roleLocation: "experience:experience2.location",
    roleDate: "experience:experience2.date",
    tags: [
      {
        name: "Python",
        level: 3,
      },
      {
        name: "Java",
        level: 3,
      },
      {
        name: "C",
        level: 2,
      },
      {
        name: "Bash",
        level: 2,
      },
      {
        name: "OCaml",
        level: 1,
      },
    ],
    points: [
      {
        text: "experience:experience2.points.point1",
      },
      {
        text: "experience:experience2.points.point2",
      },
      {
        text: "experience:experience2.points.point3",
      },
    ],
  },
  {
    type: "work", // either school or work
    orientation: "left", // refers to which side image is on
    imageLink: "/images/experience/mcgill2.jpeg",
    roleTitle: "experience:experience1.title",
    roleLocation: "experience:experience1.location",
    roleDate: "experience:experience1.date",
    tags: [
      {
        name: "Python",
        level: 3,
      },
      {
        name: "Unix/Linux",
        level: 2,
      },
      {
        name: "Docker ",
        level: 1,
      },
      {
        name: "Wireshark",
        level: 1,
      },
    ],
    points: [
      {
        text: "experience:experience1.points.point1",
      },
      {
        text: "experience:experience1.points.point2",
      },
      {
        text: "experience:experience1.points.point3",
      },
    ],
  },
];
